module.exports = __webpack_public_path__ + "static/media/logo.29663624.webp";